(function () {
  'use strict';

  if (window.__AZUR_DELIVERY_FEE_V2_LOADED__) return;
  window.__AZUR_DELIVERY_FEE_V2_LOADED__ = true;

  var config = window.AzurDeliveryFeeConfig || {};
  var feeVariantId = Number(config.variantId || 0);
  var feeHandle = String(
    config.productHandle || 'delivery-and-collection-fee'
  );

  var root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  var syncPromise = null;
  var reconcileTimer = null;
  var checkoutInProgress = false;

  function route(path) {
    return root + String(path || '').replace(/^\//, '');
  }

  async function jsonRequest(path, options) {
    var response = await fetch(route(path), options || {});
    var data = null;

    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      var message =
        (data && (data.description || data.message)) ||
        'The cart could not be updated.';

      throw new Error(message);
    }

    return data;
  }

  function readCart() {
    return jsonRequest('cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    });
  }

  function isFeeItem(item) {
    if (!item) return false;

    var marked =
      item.properties &&
      String(
        item.properties._azur_delivery_fee || ''
      ).toLowerCase() === 'true';

    return (
      marked ||
      Number(item.variant_id) === feeVariantId ||
      String(item.handle || '') === feeHandle
    );
  }

  function isRentalItem(item) {
    return Boolean(
      item &&
        item.properties &&
        String(
          item.properties._azur_rental_booking || ''
        ).toLowerCase() === 'true'
    );
  }

  function cartState(cart) {
    var items =
      cart && Array.isArray(cart.items)
        ? cart.items
        : [];

    var rentals = items.filter(isRentalItem);
    var fees = items.filter(isFeeItem);

    var feeQuantity = fees.reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);

    return {
      rentals: rentals,
      fees: fees,
      feeQuantity: feeQuantity,
      valid:
        rentals.length > 0
          ? fees.length === 1 && feeQuantity === 1
          : feeQuantity === 0
    };
  }

  async function updateByKeys(updates) {
    if (!updates || Object.keys(updates).length === 0) {
      return null;
    }

    return jsonRequest('cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        updates: updates
      })
    });
  }

  async function addFeeItem() {
    if (!feeVariantId) {
      throw new Error(
        'The delivery and collection fee product is not configured.'
      );
    }

    return jsonRequest('cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: feeVariantId,
            quantity: 1,
            properties: {
              _azur_delivery_fee: 'true'
            }
          }
        ]
      })
    });
  }

  async function reconcileCart(options) {
    options = options || {};

    if (syncPromise) {
      return syncPromise;
    }

    syncPromise = (async function () {
      document.documentElement.classList.add(
        'azur-delivery-fee-is-syncing'
      );

      var changed = false;
      var cart = await readCart();
      var state = cartState(cart);
      var updates = {};

      /*
       * Aucun matériel de location :
       * tous les éventuels forfaits sont retirés.
       */
      if (state.rentals.length === 0) {
        state.fees.forEach(function (item) {
          updates[item.key] = 0;
        });
      }

      /*
       * Au moins une location :
       * on garde un seul forfait à quantité 1.
       */
      if (
        state.rentals.length > 0 &&
        state.fees.length > 0
      ) {
        state.fees.forEach(function (item, index) {
          var wantedQuantity = index === 0 ? 1 : 0;

          if (
            Number(item.quantity || 0) !==
            wantedQuantity
          ) {
            updates[item.key] = wantedQuantity;
          }
        });
      }

      if (Object.keys(updates).length > 0) {
        cart = await updateByKeys(updates);
        changed = true;
        state = cartState(cart);
      }

      /*
       * Une location existe mais aucun forfait :
       * ajout du forfait.
       */
      if (
        state.rentals.length > 0 &&
        state.fees.length === 0
      ) {
        await addFeeItem();

        cart = await readCart();
        changed = true;
        state = cartState(cart);
      }

      decorateCart(cart);

      /*
       * Rechargement uniquement si une vraie correction
       * a été effectuée dans le panier.
       */
      if (
        changed &&
        options.reloadOnChange &&
        !window.__AZUR_CART_RELOADING__
      ) {
        window.__AZUR_CART_RELOADING__ = true;
        window.location.reload();
      }

      return {
        cart: cart,
        changed: changed,
        valid: state.valid
      };
    })();

    try {
      return await syncPromise;
    } finally {
      syncPromise = null;

      document.documentElement.classList.remove(
        'azur-delivery-fee-is-syncing'
      );
    }
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(amount);
    } catch (error) {
      return (
        amount.toFixed(2) +
        ' ' +
        (currency || 'EUR')
      );
    }
  }

  function closestCartRow(link) {
    return link.closest(
      '.cart-item, tr, li, .cart-drawer-item, [data-cart-item]'
    );
  }

  function decorateFeeRows() {
    var selector =
      'a[href*="/products/' +
      feeHandle +
      '"]';

    var links =
      document.querySelectorAll(selector);

    links.forEach(function (link) {
      var row = closestCartRow(link);

      if (!row) return;

      row.setAttribute(
        'data-azur-delivery-fee-row',
        'true'
      );

      row.classList.add(
        'azur-delivery-fee-row'
      );

      var nameNode =
        row.querySelector('.cart-item__name');

      var details =
        row.querySelector('.cart-item__details') ||
        (nameNode
          ? nameNode.parentElement
          : null) ||
        link.parentElement;

      if (
        details &&
        !details.querySelector(
          '.azur-delivery-fee-line-note'
        )
      ) {
        var note =
          document.createElement('p');

        note.className =
          'azur-delivery-fee-line-note';

        note.textContent =
          'Fixed once per order. Includes one delivery and one collection.';

        details.appendChild(note);
      }
    });
  }

  function buildBreakdown(cart) {
    var items =
      cart && Array.isArray(cart.items)
        ? cart.items
        : [];

    var currency = cart.currency || 'EUR';

    var rentalTotal = 0;
    var feeTotal = 0;
    var otherTotal = 0;

    items.forEach(function (item) {
      var linePrice = Number(
        item.final_line_price != null
          ? item.final_line_price
          : item.line_price
      );

      if (isFeeItem(item)) {
        feeTotal += linePrice;
      } else if (isRentalItem(item)) {
        rentalTotal += linePrice;
      } else {
        otherTotal += linePrice;
      }
    });

    var wrapper =
      document.createElement('div');

    wrapper.className =
      'azur-order-breakdown';

    wrapper.setAttribute(
      'data-azur-order-breakdown',
      'true'
    );

    var html =
      '<div class="azur-order-breakdown__heading">' +
        'Order total' +
      '</div>' +

      '<div class="azur-order-breakdown__line">' +
        '<span>Equipment rental</span>' +
        '<strong>' +
          formatMoney(
            rentalTotal,
            currency
          ) +
        '</strong>' +
      '</div>';

    if (otherTotal > 0) {
      html +=
        '<div class="azur-order-breakdown__line">' +
          '<span>Other items</span>' +
          '<strong>' +
            formatMoney(
              otherTotal,
              currency
            ) +
          '</strong>' +
        '</div>';
    }

    html +=
      '<div class="azur-order-breakdown__line azur-order-breakdown__line--fee">' +
        '<span>' +
          'Delivery &amp; collection' +
          '<small>One fixed fee per order</small>' +
        '</span>' +
        '<strong>' +
          formatMoney(
            feeTotal,
            currency
          ) +
        '</strong>' +
      '</div>' +

      '<div class="azur-order-breakdown__total">' +
        '<span>Total</span>' +
        '<strong>' +
          formatMoney(
            cart.total_price,
            currency
          ) +
        '</strong>' +
      '</div>';

    wrapper.innerHTML = html;

    return wrapper;
  }

  function decorateBreakdowns(cart) {
    document
      .querySelectorAll(
        '[data-azur-order-breakdown="true"]'
      )
      .forEach(function (node) {
        node.remove();
      });

    var targets = [
      document.querySelector(
        '#main-cart-footer .cart__blocks'
      ),

      document.querySelector(
        '.cart__footer .cart__blocks'
      ),

      document.querySelector(
        '#CartDrawer-Footer .drawer__footer'
      ),

      document.querySelector(
        'cart-drawer .drawer__footer'
      )
    ].filter(Boolean);

    var uniqueTargets =
      targets.filter(
        function (target, index, array) {
          return (
            array.indexOf(target) === index
          );
        }
      );

    uniqueTargets.forEach(function (target) {
      var breakdown =
        buildBreakdown(cart);

      var checkoutArea =
        target.querySelector(
          '.cart__ctas, [name="checkout"], .drawer__footer-buttons'
        );

      if (checkoutArea) {
        target.insertBefore(
          breakdown,
          checkoutArea
        );
      } else {
        target.appendChild(breakdown);
      }
    });
  }

  function decorateCart(cart) {
    if (!cart) return;

    decorateFeeRows();
    decorateBreakdowns(cart);

    /*
     * Le nombre réel d’équipements est lu depuis
     * _azur_equipment_quantity.
     *
     * Le produit de 30 € n’est jamais compté.
     */
    var count = (cart.items || [])
      .filter(isRentalItem)
      .reduce(function (sum, item) {
        var properties =
          item.properties || {};

        return (
          sum +
          Number(
            properties._azur_equipment_quantity ||
              0
          )
        );
      }, 0);

    document
      .querySelectorAll(
        '[data-azur-equipment-count]'
      )
      .forEach(function (node) {
        node.textContent = String(count);
      });
  }

  function showCartError(message) {
    var old =
      document.querySelector(
        '[data-azur-delivery-fee-error]'
      );

    if (old) {
      old.remove();
    }

    var error =
      document.createElement('div');

    error.setAttribute(
      'data-azur-delivery-fee-error',
      'true'
    );

    error.className =
      'azur-delivery-fee-error';

    error.textContent = message;

    var target =
      document.querySelector(
        '#main-cart-footer .cart__blocks'
      ) ||
      document.querySelector(
        '#CartDrawer-Footer .drawer__footer'
      ) ||
      document.querySelector(
        'cart-drawer .drawer__footer'
      ) ||
      document.body;

    target.prepend(error);
  }

  function checkoutTargetFromEvent(event) {
    var target = event.target;

    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest(
      'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]'
    );
  }

  async function saveRentalCartDetails(button) {
    if (!button || !button.closest) return;

    var form = button.closest(
      '.azur-rental-cart-page__form'
    );

    if (!form) return;

    if (!form.checkValidity()) {
      form.reportValidity();

      throw new Error(
        'Please complete your customer and delivery information before payment.'
      );
    }

    /*
     * The custom cart section builds the order note in its submit handler.
     * Because this file verifies the delivery fee before checkout, the normal
     * browser submit is intercepted. Dispatch the event here so the note is
     * built, then persist both the note and every cart attribute explicitly.
     */
    var submitEvent = new Event(
      'submit',
      {
        bubbles: false,
        cancelable: true
      }
    );

    if (!form.dispatchEvent(submitEvent)) {
      throw new Error(
        'Please update your booking details before payment.'
      );
    }

    var attributes = {};

    form
      .querySelectorAll('[name^="attributes["]')
      .forEach(function (field) {
        var match = field.name.match(
          /^attributes\[(.+)\]$/
        );

        if (!match) return;

        if (
          (field.type === 'checkbox' ||
            field.type === 'radio') &&
          !field.checked
        ) {
          return;
        }

        attributes[match[1]] = field.value;
      });

    var noteField = form.querySelector(
      '[name="note"]'
    );

    await jsonRequest('cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: attributes,
        note: noteField ? noteField.value : ''
      })
    });
  }

  async function handleCheckout(
    event,
    button
  ) {
    if (checkoutInProgress) return;

    checkoutInProgress = true;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (button) {
      button.disabled = true;

      button.setAttribute(
        'aria-busy',
        'true'
      );
    }

    try {
      await saveRentalCartDetails(button);

      var result =
        await reconcileCart({
          reloadOnChange: false
        });

      if (!result.valid) {
        throw new Error(
          'The €30 delivery and collection fee could not be secured in the cart.'
        );
      }

      window.location.assign(
        route('checkout')
      );
    } catch (error) {
      console.error(
        '[Azur delivery fee]',
        error
      );

      showCartError(
        error && error.message
          ? error.message
          : 'The cart could not be verified before payment.'
      );

      checkoutInProgress = false;

      if (button) {
        button.disabled = false;

        button.removeAttribute(
          'aria-busy'
        );
      }
    }
  }

  function scheduleReconcile() {
    window.clearTimeout(
      reconcileTimer
    );

    /*
     * Dawn met à jour le panier en Ajax.
     * On attend sa mise à jour avant de contrôler.
     */
    reconcileTimer =
      window.setTimeout(function () {
        reconcileCart({
          reloadOnChange: true
        }).catch(function (error) {
          console.error(
            '[Azur delivery fee]',
            error
          );
        });
      }, 1100);
  }

  document.addEventListener(
    'click',
    function (event) {
      var checkoutButton =
        checkoutTargetFromEvent(event);

      if (checkoutButton) {
        handleCheckout(
          event,
          checkoutButton
        );

        return;
      }

      var target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      if (
        target.closest(
          'cart-remove-button, .cart-remove-button, [data-cart-remove], quantity-input button, .quantity__button'
        )
      ) {
        scheduleReconcile();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      if (
        target.matches(
          'input[name="updates[]"], quantity-input input, .quantity__input'
        )
      ) {
        scheduleReconcile();
      }
    },
    true
  );

  function boot() {
    var isCartPage =
      window.location.pathname
        .replace(/\/$/, '') === '/cart';

    reconcileCart({
      reloadOnChange: isCartPage
    }).catch(function (error) {
      console.error(
        '[Azur delivery fee]',
        error
      );
    });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  window.addEventListener(
    'pageshow',
    function (event) {
      if (!event.persisted) return;

      reconcileCart({
        reloadOnChange: false
      }).catch(function (error) {
        console.error(
          '[Azur delivery fee]',
          error
        );
      });
    }
  );

  window.AzurDeliveryFee = {
    reconcile: reconcileCart,
    readCart: readCart,
    isFeeItem: isFeeItem,
    isRentalItem: isRentalItem
  };
})();
(function () {
  'use strict';

  if (window.__AZUR_FEE_VISUAL_FIX_LOADED__) {
    return;
  }

  window.__AZUR_FEE_VISUAL_FIX_LOADED__ = true;

  /*
   * Ce correctif visuel doit fonctionner uniquement
   * sur la page panier, jamais sur les fiches produit.
   */
  var currentPath = window.location.pathname.replace(/\/+$/, '');
  var isCartPage = currentPath === '/cart' || currentPath.endsWith('/cart');

  if (!isCartPage) {
    return;
  }

  var feeHandle = 'delivery-and-collection-fee';
  var updateTimer = null;
  var updateRunning = false;

  function shopRoute(path) {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return root + String(path || '').replace(/^\//, '');
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    var locale =
      document.documentElement.lang ||
      navigator.language ||
      'en-GB';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(amount);
    } catch (error) {
      return '€' + amount.toFixed(2);
    }
  }

  function isFeeItem(item) {
    if (!item) {
      return false;
    }

    var properties = item.properties || {};

    return (
      String(item.handle || '') === feeHandle ||
      normalizeText(properties._azur_delivery_fee) === 'true'
    );
  }

  function findElementsByExactText(text) {
    var searchedText = normalizeText(text);

    return Array.from(
      document.querySelectorAll(
        'a, span, strong, p, div, h1, h2, h3, h4, h5'
      )
    ).filter(function (element) {
      return normalizeText(element.textContent) === searchedText;
    });
  }

  function findFeeCard(element) {
    if (!element) {
      return null;
    }

    var row = element.closest(
      [
        '.cart-item',
        'cart-item',
        '.cart-drawer-item',
        '[data-cart-item]',
        '.booking-summary__item',
        '.booking-item',
        '.rental-cart-item',
        'article',
        'tr',
        'li'
      ].join(', ')
    );

    if (row) {
      return row;
    }

    /*
     * Recherche du petit bloc qui contient les champs
     * Start date, End date et Update booking details.
     */
    var parent = element.parentElement;
    var level = 0;

    while (parent && level < 8) {
      var text = normalizeText(parent.innerText);

      var looksLikeFeeCard =
        text.indexOf('delivery and collection fee') !== -1 &&
        (
          text.indexOf('start date') !== -1 ||
          text.indexOf('update booking details') !== -1 ||
          text.indexOf('number of scooters') !== -1
        );

      /*
       * Évite de masquer toute la page.
       */
      if (
        looksLikeFeeCard &&
        text.length < 1500
      ) {
        return parent;
      }

      parent = parent.parentElement;
      level += 1;
    }

    return null;
  }

  function hideFeeProductCards() {
    var candidates = [];

    document
      .querySelectorAll(
        'a[href*="/products/' + feeHandle + '"]'
      )
      .forEach(function (element) {
        candidates.push(element);
      });

    document
      .querySelectorAll(
        '[data-azur-delivery-fee-row="true"]'
      )
      .forEach(function (element) {
        candidates.push(element);
      });

    findElementsByExactText(
      'Delivery and collection fee'
    ).forEach(function (element) {
      candidates.push(element);
    });

    candidates.forEach(function (element) {
      var card =
        element.matches &&
        element.matches(
          '[data-azur-delivery-fee-row="true"]'
        )
          ? element
          : findFeeCard(element);

      if (!card) {
        return;
      }

      card.setAttribute(
        'data-azur-hidden-fee-product',
        'true'
      );

      card.setAttribute(
        'aria-hidden',
        'true'
      );

      card.style.setProperty(
        'display',
        'none',
        'important'
      );
    });

    /*
     * Supprime l’ancien deuxième bloc de total ajouté
     * par la première version du script.
     */
    document
      .querySelectorAll(
        '[data-azur-order-breakdown="true"]'
      )
      .forEach(function (element) {
        element.remove();
      });
  }

  function getLeafElements(root) {
    if (!root) {
      return [];
    }

    var elements = [root].concat(
      Array.from(root.querySelectorAll('*'))
    );

    return elements.filter(function (element) {
      return (
        element.children.length === 0 &&
        normalizeText(element.textContent) !== ''
      );
    });
  }

  function findExactTextInside(root, searchedText) {
    var normalized = normalizeText(searchedText);

    return getLeafElements(root).find(function (element) {
      return normalizeText(element.textContent) === normalized;
    });
  }

  function containsPrice(text) {
    return (
      /[€$£]/.test(String(text || '')) ||
      /\d+[.,]\d{2}/.test(String(text || ''))
    );
  }

  function findPriceElement(row, excludedText) {
    var excluded = normalizeText(excludedText);

    var elements = getLeafElements(row).filter(function (element) {
      var text = normalizeText(element.textContent);

      return (
        text !== excluded &&
        containsPrice(element.textContent)
      );
    });

    return elements.length
      ? elements[elements.length - 1]
      : null;
  }

  function findCompactSummaryRow(labelElement) {
    if (!labelElement) {
      return null;
    }

    var current = labelElement;
    var level = 0;

    while (current && level < 7) {
      var text = normalizeText(current.innerText);

      if (
        text.length < 250 &&
        containsPrice(current.innerText)
      ) {
        return current;
      }

      current = current.parentElement;
      level += 1;
    }

    return labelElement.parentElement;
  }

  function cleanClonedRow(row) {
    row
      .querySelectorAll('[id]')
      .forEach(function (element) {
        element.removeAttribute('id');
      });

    row
      .querySelectorAll(
        'button, input, select, a'
      )
      .forEach(function (element) {
        element.remove();
      });
  }

  function addFeeLineToSummary(cart) {
    document
      .querySelectorAll(
        '[data-azur-inline-fee-row="true"]'
      )
      .forEach(function (element) {
        element.remove();
      });

    var items = Array.isArray(cart.items)
      ? cart.items
      : [];

    var feeTotal = items
      .filter(isFeeItem)
      .reduce(function (total, item) {
        var linePrice =
          item.final_line_price != null
            ? item.final_line_price
            : item.line_price;

        return total + Number(linePrice || 0);
      }, 0);

    if (feeTotal <= 0) {
      return;
    }

    var currency = cart.currency || 'EUR';

    var rentalLabels =
      findElementsByExactText(
        'Rental subtotal'
      );

    rentalLabels.forEach(function (labelElement) {
      var rentalRow =
        findCompactSummaryRow(labelElement);

      if (!rentalRow) {
        return;
      }

      /*
       * Duplique uniquement la ligne Rental subtotal
       * afin de conserver exactement son design.
       */
      var feeRow =
        rentalRow.cloneNode(true);

      cleanClonedRow(feeRow);

      feeRow.setAttribute(
        'data-azur-inline-fee-row',
        'true'
      );

      var clonedLabel =
        findExactTextInside(
          feeRow,
          'Rental subtotal'
        );

      var clonedPrice =
        findPriceElement(
          feeRow,
          'Rental subtotal'
        );

      if (clonedLabel) {
        clonedLabel.textContent =
          'Delivery & collection';
      }

      if (clonedPrice) {
        clonedPrice.textContent =
          formatMoney(
            feeTotal,
            currency
          );
      }

      rentalRow.insertAdjacentElement(
        'afterend',
        feeRow
      );
    });

    /*
     * Le total noir est remplacé par le vrai total Shopify,
     * forfait de 30 € compris.
     */
    var totalLabels =
      findElementsByExactText(
        'Total before checkout'
      );

    totalLabels.forEach(function (labelElement) {
      var totalRow =
        findCompactSummaryRow(labelElement);

      var totalPriceElement =
        findPriceElement(
          totalRow,
          'Total before checkout'
        );

      if (totalPriceElement) {
        totalPriceElement.textContent =
          formatMoney(
            cart.total_price,
            currency
          );
      }
    });
  }

  async function applyVisualFix() {
    if (updateRunning) {
      return;
    }

    updateRunning = true;

    try {
      /*
       * Masquage immédiat avant même la lecture du panier.
       */
      hideFeeProductCards();

      var response = await fetch(
        shopRoute('cart.js'),
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          },
          credentials: 'same-origin'
        }
      );

      if (!response.ok) {
        throw new Error(
          'Unable to read the cart.'
        );
      }

      var cart = await response.json();

      hideFeeProductCards();
      addFeeLineToSummary(cart);
    } catch (error) {
      console.error(
        '[Azur fee visual fix]',
        error
      );
    } finally {
      updateRunning = false;
    }
  }

  function scheduleVisualFix(delay) {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(
      applyVisualFix,
      typeof delay === 'number'
        ? delay
        : 150
    );
  }

  function startVisualFix() {
    hideFeeProductCards();

    scheduleVisualFix(50);
    scheduleVisualFix(700);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startVisualFix,
      {
        once: true
      }
    );
  } else {
    startVisualFix();
  }

  /*
   * Nouvelle application après une modification Ajax du panier.
   */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      if (
        target.closest(
          [
            'cart-remove-button',
            '.cart-remove-button',
            '[data-cart-remove]',
            'quantity-input button',
            '.quantity__button',
            '[data-add-booking]',
            '[name="checkout"]'
          ].join(', ')
        )
      ) {
        scheduleVisualFix(1000);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      if (
        target.matches(
          [
            'input[name="updates[]"]',
            'quantity-input input',
            '.quantity__input'
          ].join(', ')
        )
      ) {
        scheduleVisualFix(1000);
      }
    },
    true
  );

  document.addEventListener(
    'cart:updated',
    function () {
      scheduleVisualFix(100);
    }
  );

  document.addEventListener(
    'cart:refresh',
    function () {
      scheduleVisualFix(100);
    }
  );

  window.addEventListener(
    'pageshow',
    function () {
      scheduleVisualFix(100);
    }
  );
})();
